<template>
  <v-snackbar v-model="visible" color="blue darken-2" :timeout="5000" top>
    {{ $t('verification') }}
    <span class="white--text" style="text-decoration: underline; cursor: pointer;" @click="signup()">{{ $t('increase-limit') }}</span> !

    <template v-slot:action="{ attrs }">
      <v-btn v-if="$vuetify.breakpoint.smAndUp" @click="signup()" light elevation="0" class="primary--text mr-2" v-bind="attrs">
        {{ $t('actions.signup') }}
      </v-btn>
      <v-btn text v-bind="attrs" @click="visible = false">
        {{ $t('actions.close') }}
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
  export default {
    name: 'AccountRequiredForMoreChecksNotification',
    data () {
      return {
        visible: false
      }
    },
    methods: {
      signup() {
        this.visible = false
        this.$account.emit('dialog/signup/open')
      }
    },
    mounted () {
      this.$bus.on('notification/account_required_for_more_checks', () => {
        this.visible = true
      })
    }
  }
</script>

<i18n>
{
	"en": {
		"increase-limit": "create a free account to increase this limit",
		"verification": "Please wait a few moments before your next check, or"
	},
	"es": {
		"increase-limit": "crea una cuenta gratuita para aumentar este límite",
		"verification": "Espere unos momentos antes de su próxima comprobación, o"
	},
	"fr": {
		"increase-limit": "créez gratuitement un compte pour augmenter cette limite",
		"verification": "Merci de patienter quelques instants avant votre prochaine vérification, ou"
	},
	"it": {
		"increase-limit": "crea un account gratuito per aumentare questo limite",
		"verification": "Attendi qualche momento prima della prossima verifica, o"
	},
	"pt": {
		"increase-limit": "crie uma conta gratuita para aumentar este limite",
		"verification": "Por favor aguarde alguns momentos antes da sua próxima verificação, ou"
	},
	"pl": {
		"increase-limit": "utwórz bezpłatne konto, aby zwiększyć ten limit",
		"verification": "Poczekaj chwilę przed następną weryfikacją lub"
	}
}
</i18n>
